import { createApp, reactive, provide, h } from 'vue'
import App from './App.vue'
import router from './router';
import { ApolloClient, InMemoryCache, gql, from } from '@apollo/client';
import { DefaultApolloClient } from '@vue/apollo-composable';
import { Observable } from 'apollo-link';
import jwt_decode from "jwt-decode";
import { IonicVue, isPlatform } from '@ionic/vue';
import CountryFlag from 'vue-country-flag-next'
//import VCalendar from 'v-calendar';
import * as IonComponents from '@ionic/vue';
import { SetupCalendar, Calendar, DatePicker } from 'v-calendar';
import VueObserveVisibility from 'vue-observe-visibility'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'
import { Device } from '@capacitor/device'
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { unref } from 'vue'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

import { createStore } from 'vuex'
import braintree from './braintree'

import { ApolloLink, concat } from 'apollo-link';
import { onError } from 'apollo-link-error'
import { HttpLink } from 'apollo-link-http'
import { RetryLink } from 'apollo-link-retry'
import { setContext } from '@apollo/client/link/context';
import { toastController } from '@ionic/vue';
import translateGlobalProperties from './plugins/translateGlobalProperties'
import translate from './plugins/translate'
//import { Storage } from '@capacitor/storage';
import Storage from "./plugins/storage";
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import VueApexCharts from "vue3-apexcharts";
import vueBraintree from 'vue-braintree'
import VueCountdown from '@chenfengyuan/vue-countdown'
import i18next from 'i18next';
import vueTouchEvents from "vue3-touch-events"

const en = require('./i18nData/en');
const de = require('./i18nData/de');
const it = require('./i18nData/it');
const fr = require('./i18nData/fr');
const cz = require('./i18nData/cz');
const nl = require('./i18nData/nl');
const es = require('./i18nData/es');
const cn = require('./i18nData/cn');

i18next.init({
  lng: 'de',
  debug: false,
  resources: {
    en,
    de,
    it,
    fr,
    cz,
    nl,
    es,
    cn
  }
})


export async function initAndroidSafeArea(){
  try{
    const info = await Device.getInfo();
    const html = document.documentElement;

    // Android-Flag + SDK-Attribut setzen/entfernen
    if ((info.platform || '').toLowerCase() === 'android'){
      html.classList.add('android-only','android');
      if (info.androidSDKVersion) {
        html.setAttribute('data-android-sdk', String(info.androidSDKVersion));
      }
    } else {
      html.classList.remove('android-only','android');
      html.removeAttribute('data-android-sdk');
    }
  }catch{/* ignore */}

  // safe-area-inset-top -> --measured-safe-top
  const measure = () => {
    const probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;top:0;left:0;visibility:hidden;pointer-events:none;padding-top:env(safe-area-inset-top)';
    document.body.appendChild(probe);
    const px = parseFloat(getComputedStyle(probe).paddingTop) || 0;
    probe.remove();

    const html = document.documentElement;
    if (px > 0.5) {
      html.style.setProperty('--measured-safe-top', px + 'px');
      html.classList.add('has-measured-safe-top');
    } else {
      html.style.removeProperty('--measured-safe-top');
      html.classList.remove('has-measured-safe-top');
    }

  };

  // einmal messen…
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', measure, { once:true });
  } else {
    measure();
  }

  // …und auf Änderungen reagieren
  const rerun = () => measure();
  window.addEventListener('resize', rerun);
  window.addEventListener('orientationchange', rerun);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', rerun);
  document.addEventListener('fullscreenchange', rerun);
}

export async function initIOSSafeArea() {
  try {
    const info = await Device.getInfo();
    const html = document.documentElement;

    if ((info.platform || '').toLowerCase() === 'ios') {
      html.classList.add('ios-only', 'ios');
    } else {
      html.classList.remove('ios-only', 'ios');
    }
  } catch {
    
  }
}

async function isPixel6 () {
  try {
    const info = await Device.getInfo()
    const model = (info.model || '').toLowerCase()
    return (info.platform || '').toLowerCase() === 'android' &&
           (model.includes('pixel 6') || model.includes('oriole') || model.includes('raven'))
  } catch {
    return false
  }
}

export async function isPixel8Pro () {
  try {
    const info = await Device.getInfo()
    const model = (info.model || '').toLowerCase()
    return (info.platform || '').toLowerCase() === 'android' &&
           (model.includes('pixel 8 pro') || model.includes('husky'))
  } catch {
    return false
  }
}



Storage.getItem('language').then(res => {
  const lang = res ? res : 'de'
  i18next.changeLanguage(lang)
})


const diplayErrorToast = (error) => {
  toastController
  .create({
    message: error,
    duration: 5000,
    color: 'danger'
  }).then(res => res.present())

}
export const store = createStore({
  state () {
    return {
      selectedOrganization: '',
      token:  '',
      userdata: '',
      language: 'de',
      selectedClub: null,
      selectedPro: null,
      selectedIndex: 0,
      clubs: null,
      httpLink: 'https://backend-cio-online-frontend-mobile.smrtp.net'
    }
  },
  modules: {
    braintree,
  },
  actions: {
    logout({commit}){
      return new Promise(async (resolve, reject) => {
        commit('logout')
        const clubNumber = await Storage.getItem('clubNumber')
        await Storage.removeItem('accessToken' + clubNumber)
        await Storage.removeItem('refreshToken' + clubNumber)
        await Storage.removeItem('accessToken')
        await Storage.removeItem('refreshToken')
        resolve()
      })
    },
    login({commit}){
      return new Promise((resolve, reject) => {
        commit('login')
        resolve()
      })
    },
    setToken({commit}, value){
      return new Promise((resolve, reject) => {
        commit('setToken', value)
        resolve()
      })
    },
    setUserdata({commit}, value){
      return new Promise((resolve, reject) => {
        commit('setUserdata', value)
        resolve()
      })
    },
    setLanguage({commit}){
      return new Promise((resolve, reject) => {
        commit('setLanguage')
        resolve()
      })
    },
    async setHttpLink({ commit }) {
      let httpLink
      if (isPlatform('capacitor')) {
        httpLink = await Storage.getItem('httpLink') || "https://backend-cio-online-frontend-mobile.smrtp.net"
      }
      else if (window.location.hostname == "localhost")
        httpLink = "http://localhost:4000" 
      else if (window.location.hostname == "192.168.5.190")
        httpLink = "http://192.168.5.190:4000" 
      else {
        httpLink = await Storage.getItem('httpLink') ||
          (window.location.protocol + '//backend-' + window.location.hostname)
      }
      commit('setHttpLink', httpLink)
    },
    setClubs({commit}){
      return new Promise((resolve, reject) => {
        commit('setClubs')
        resolve()
      })
    },
    getClubs({commit}){
      return new Promise((resolve, reject) => {
        commit('getClubs')
        resolve()
      })
    },
    getSelectedClub({commit}){
      return new Promise((resolve, reject) => {
        commit('getSelectedClub')
        resolve()
      })
    },
    setSelectedClub({commit}, club){
      return new Promise((resolve, reject) => {
        commit('setSelectedClub', club)
        resolve()
      })
    },
    getSelectedPro({commit}){
      return new Promise((resolve, reject) => {
        commit('getSelectedPro')
        resolve()
      })
    },
    setSelectedPro({commit}, pro){
      return new Promise((resolve, reject) => {
        commit('setSelectedPro', pro)
        resolve()
      })
    },
    getSelectedIndex({commit}){
      return new Promise((resolve, reject) => {
        commit('getSelectedIndex')
        resolve()
      })
    },
    setSelectedIndex({commit}, index){
      return new Promise((resolve, reject) => {
        commit('setSelectedIndex', index)
        resolve()
      })
    },
    setAccessControl({commit}, ac){
      return new Promise((resolve, reject) => {
        commit('setAccessControl', ac)
        resolve()
      })
    },
    setUserDataImageUrl({commit}, value){
      return new Promise((resolve, reject) => {
        commit('setUserDataImageUrl', value)
        resolve()
      })
    },
    setUserHCP({commit}, value){
      return new Promise((resolve, reject) => {
        commit('setUserHCP', value)
        resolve()
      })
    },
    setUserHCPDate({commit}, value){
      return new Promise((resolve, reject) => {
        commit('setUserHCPDate', value)
        resolve()
      })
    },
    setUserDataShowAvatar({commit}, value){
      return new Promise((resolve, reject) => {
        commit('setUserDataShowAvatar', value)
        resolve()
      })
    },
    setUserDataDoRecharge({commit}, value){
      return new Promise((resolve, reject) => {
        commit('setUserDataDoRecharge', value)
        resolve()
      })
    },
    setUserDataRechargeLimit({commit}, value){
      return new Promise((resolve, reject) => {
        commit('setUserDataRechargeLimit', value)
        resolve()
      })
    },
    setUserDataRechargeAmount({commit}, value){
      return new Promise((resolve, reject) => {
        commit('setUserDataRechargeAmount', value)
        resolve()
      })
    },
    setUserDataShowName({commit}, value){
      return new Promise((resolve, reject) => {
        commit('setUserDataShowName', value)
        resolve()
      })
    },
    setUserDataShowHCP({commit}, value){
      return new Promise((resolve, reject) => {
        commit('setUserDataShowHCP', value)
        resolve()
      })
    },
    setUserDataShowGender({commit}, value){
      return new Promise((resolve, reject) => {
        commit('setUserDataShowGender', value)
        resolve()
      })
    },
    deleteUserDataImageUrl({commit}){
      return new Promise((resolve, reject) => {
        commit('deleteUserDataImageUrl')
        resolve()
      })
    },
    setUserDataFriendBatch({commit}, value){
      return new Promise((resolve, reject) => {
        commit('setUserDataFriendBatch', value)
        resolve()
      })
    },
    refreshToken({commit}){
      return new Promise((resolve, reject) => {
        commit('refreshToken')
        resolve()
      })
    },
  },
  mutations: {
    async logout(state){
      state.token = ''
      state.userdata = null
      //store.dispatch('token')
    },
    async login(state){
      const { clubInfo } = getClubInfo();

      const clubNumber = await Storage.getItem('clubNumber')
      state.token = await Storage.getItem('accessToken' + clubNumber) || ''
      if (state.token != "") {
        state.userdata = jwt_decode(state.token)
      }
    },
    setToken(state, value){
      state.token = value
    },
    setUserdata(state, value){
      state.userdata = value
    },
    async setLanguage(state){
      state.language = await Storage.getItem('language') || 'de'
    },
    setHttpLink(state, link) {
      state.httpLink = link
    },
    setClubs(state){
      Storage.setItem('clubs', state.clubs)
    },
    async getClubs(state){
      state.clubs = await Storage.getItem('clubs') || null
    },
    async getSelectedClub(state){
      await Storage.getItem('selectedClub')
        .then(res => {
          state.selectedClub = res
          return
        })
    },
    setSelectedClub(state, club){
      state.selectedClub = club
      Storage.setItem('selectedClub', club)
    },
    async getSelectedPro(state){
      await Storage.getItem('selectedPro')
        .then(res => {
          state.selectedPro = JSON.parse(res)
          return
        })
    },
    setSelectedPro(state, pro){
      state.selectedPro = pro
      Storage.setItem('selectedPro', pro)
    },
    async getSelectedIndex(state){
      await Storage.getItem('selectedIndex')
        .then(res => {
          state.selectedIndex = res
          return
        })
    },
    setSelectedIndex(state, index){
      state.selectedIndex = index
      Storage.setItem('selectedIndex', index)
    },
    setAccessControl(state, ac){
      state.ac = ac
    },
    setUserDataImageUrl(state, value){
      state.userdata.imageUrl = value
    },
    setUserHCP(state, value){
      state.userdata.hcp = value
    },
    setUserHCPDate(state, value){
      state.userdata.hcpLastSync = value
    },
    setUserDataShowAvatar(state, value){
      state.userdata.showAvatar = value
    },
    setUserDataDoRecharge(state, value){
      state.userdata.doRecharge = value
    },
    setUserDataRechargeLimit(state, value){
      state.userdata.rechargeLimit = value
    },
    setUserDataRechargeAmount(state, value){
      state.userdata.rechargeAmount = value
    },
    setUserDataShowName(state, value){
      state.userdata.showName = value
    },
    setUserDataShowHCP(state, value){
      state.userdata.showHCP = value
    },
    setUserDataShowGender(state, value){
      state.userdata.showGender = value
    },
    setUserDataFriendBatch(state, value) {
      state.userdata.friendBatchNum = value
    },
    deleteUserDataImageUrl(state){
      state.userdata.imageUrl = null
    },
    async refreshToken(state){
      await getNewToken()
    },
  },
  getters: {
    isLoggedIn: state => !!state.token,
    UserData: state => state.userdata,
    language: state => state.language,
    clubs: state => state.clubs,
    selectedClub: state => state.selectedClub,
    selectedPro: state => state.selectedPro,
    selectedIndex: state => state.selectedIndex,
    ac: state => state.ac,
    token: state => {
      return state.token;
    },
    httpLink: state => state.httpLink
  }
})

//store.setToken()
store.dispatch('login')
store.dispatch('setLanguage')
store.dispatch('getClubs')
store.dispatch('getSelectedClub')
store.dispatch('getSelectedPro')
store.dispatch('getSelectedIndex')
await store.dispatch('setHttpLink')

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  //console.log("🚀 ~ file: main.js:420 ~ errorLink ~ graphQLErrors:", graphQLErrors[0])
  if (graphQLErrors && graphQLErrors[0].message === 'Unauthenticated') {
    return new Observable(observer => {
        getNewToken()
          .then(newAccessToken => {  
            store.token = newAccessToken
            store.userdata = jwt_decode(newAccessToken)
            //store.dispatch('setToken', newAccessToken)
            //store.dispatch('setUserdata', jwt_decode(newAccessToken))
            operation.setContext(({ headers = {} }) => ({
              headers: {
                // Re-add old headers
                ...headers,
                // Switch out old access token for new one
                authorization: `Bearer ${newAccessToken}`,
              }
            }));

            const subscriber = {
              next: observer.next.bind(observer),
              error: observer.error.bind(observer),
              complete: observer.complete.bind(observer),
            };

            return forward(operation).subscribe(subscriber);
          })
          .catch(error => {
            //console.log("🚀 ~ file: main.js:447 ~ errorLink ~ error:", error)
            // No refresh or client token available, we force user to login
            observer.error(error);
          });
      });

  } else if (graphQLErrors) {
      graphQLErrors.forEach(async error => {
        if (error.extensions.code == 'df6b0154') {
          await store.dispatch('logout')
          router.push('/home')
        }
        if (error.extensions.code != translate(error.extensions.code))
            diplayErrorToast(translate(error.extensions.code) + (error.extensions.exception && error.extensions.exception.code ? ' (' + error.extensions.exception.code + ')' : ''))
      })
    }
  }
)

const retry = new RetryLink(
  { 
    attempts : { max : Infinity },
    delay: { initial: 30000, max: 30000, jitter: false }, 
  }) 
const httpLink = new HttpLink({
  uri:  (() => store.getters['httpLink'])
  //uri:  'http://localhost:4000'
})

const defaultOptions = { 
  watchQuery: {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true
  },
  query: {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true
  },
  mutate: {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true
  }
}

const authLink = setContext(async (_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = await Storage.getItem('accessToken' + await Storage.getItem('clubNumber'))

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});


const links = ApolloLink.from([
  authLink,
  errorLink,
  concat(retry, httpLink),
]);

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache({
    addTypename: false
  }),
  link: links,
  defaultOptions,
  fetchOptions: {
    mode: 'no-cors',
  },
})

//const test = { id: '5fc8f04fad915f9ded0839b9', name: 'Leons Test Org.'}
//store.clubs = JSON.stringify(test)
//store.dispatch('setClubs')

//await setHttpLink(state)
import { setClubInfo, getClubInfo } from '@/composition'

const GET_CLUB_INFO = gql`
query getClubInfo {
    getClubInfo {
        name
        nameShort
        logo
        isBraintreePaypalMethodExist
        isBraintreeCreditCardMethodExist
        maskedNumber
        expirationDate
        appPages {
            title
            url
            icon
            showInNav
            requiresLogin
        }
        latitude
        longitude
        canCeckIn
        canRegister
        canLivescoring
        canRPR
        canPaypal
        canLastschrift
        canLastschriftRPR
        canLastschriftTeetime
        canLastschriftIndoor
        canLastschriftPro
        canLastschriftRange
        canLastschriftTrackman
        canLastschriftWellness
        canLastschriftRegisterCourse
        canLastschriftRegisterTournament
        currency
        logoHeader
        googleTagID
        showInfoScreenPopup
        paypalClientID
        askTeetimeNumHoles
        canMeteorPayment
        MeteorPaymentTypes
        MeteorScriptLink
        canNFCWallet
    }
}`

const loadClubInfo = async () => {
  try {
    const result = await apolloClient.query({
      query: GET_CLUB_INFO,
      fetchPolicy: 'no-cache', // optional
    });

    const club = result?.data?.getClubInfo;
    await setClubInfo(club);

    let token = await Storage.getItem('accessToken')
    let refreshToken = await Storage.getItem('refreshToken')
    if (token && token != '') {
      await Storage.setItem('accessToken' + club.maskedNumber, token)
      await Storage.setItem('refreshToken' + club.maskedNumber, refreshToken)
      await Storage.setItem('clubNumber', club.maskedNumber)
      await Storage.removeItem('accessToken')
      await Storage.removeItem('refreshToken')
      store.dispatch('login')
    }
    else if (club.maskedNumber != '499008') {
      token = await Storage.getItem('accessToken499008')
      refreshToken = await Storage.getItem('refreshToken499008')
      if (token && token != '') {
        await Storage.setItem('clubNumber', club.maskedNumber)
        await Storage.removeItem('accessToken499008')
        await Storage.removeItem('refreshToken499008')
        await store.dispatch('logout')
        await store.dispatch('login')
      }
      else {
        await Storage.setItem('clubNumber', club.maskedNumber)
        await store.dispatch('login')
      }
    }
    else {
      await Storage.setItem('clubNumber', club.maskedNumber)
      await store.dispatch('login')
    }


  } catch (error) {
    console.error('❌ Error loading club info:', error.message, error);
  }
};

//await loadClubInfo()

//store.dispatch('login')

/*(async () => {
  try {
    const result = await apolloClient.query({ query: getClubInfoQuery });
    const clubData = result.data.getClubInfo;

    setClubInfo(clubData);
    setAppPages(clubData.appPages);

    createApp(App).mount('#app');
  } catch (err) {
    console.error('Error fetching club info:', err);
    createApp(App).mount('#app'); // fallback
  }
})();*/


/*const userData = await apolloClient.query({
    mutationClub
  })

  console.log(userData)*/

export default store

const { clubInfo } = getClubInfo();

Storage.getItem('accessToken' + unref(clubInfo)?.maskedNumber).then(async res => {
  //await tagAndroid16();
  //Android();
  if (await isPixel6()) {
    await initAndroidSafeArea()
  }
  if (await isPixel8Pro()) {
    await initAndroidSafeArea()
  }  
  await initIOSSafeArea();
  
  store.token = res ? res : ''

  Storage.getItem('language').then(res => {
    const lang = res ? res : 'de'
    i18next.changeLanguage(lang)
    const app = createApp(
      {
        setup () {
          provide(DefaultApolloClient, apolloClient)
        },
        render() {
          return h(App)
        }
      }
    ).use(translateGlobalProperties)
    .use(IonicVue)
    .use(router)
    .use(store)
    .use(VueApexCharts)
    .use(vueBraintree)
    .use(vueTouchEvents)
    .use(VueObserveVisibility)

    app.use(SetupCalendar, {})

    app.component(VueCountdown.name, VueCountdown)
    app.component(CountryFlag.name, CountryFlag)
    app.component('DatePicker', DatePicker)
    app.component('Calendar', Calendar)
    app.component('EasyDataTable', Vue3EasyDataTable)
    //app.use(VCalendar, {})
    
    // Import all Ion Components at once
    Object.keys(IonComponents).forEach(key => {
      if (/^Ion[A-Z]\w+$/.test(key)) {
          app.component(key, IonComponents[key]);
      }
    });
  
    router.isReady().then(async () => {
      app.mount('#app');
      await loadClubInfo()
      defineCustomElements(window)
    });
  })
})


const mutation = gql`
mutation refreshAccessToken($refreshToken: String!) {
    refreshAccessToken(input: {
        refreshToken: $refreshToken
    }) {
        accessToken
    }
}`

const getNewToken = async () => {
  const refreshToken = await Storage.getItem('refreshToken' + await Storage.getItem('clubNumber'))
  const newAccessToken = await apolloClient.mutate({
    mutation,
    variables: { refreshToken: refreshToken }
  })
  .then (async res => {
    const { accessToken } = res.data.refreshAccessToken;
    await Storage.setItem('accessToken' + await Storage.getItem('clubNumber'), accessToken)
    
    await store.dispatch('setToken', accessToken)
    await store.dispatch('setUserdata', jwt_decode(accessToken))
    return accessToken;
  })
  .catch(err => {
    console.error(err)
  })
  return newAccessToken
};


